<template>
  <div>
    <order-complete v-if="isOrderSuccess && isIssue" :orderResult="orderResult"></order-complete>
    <gift-complete v-if="isOrderSuccess && isGift" :orderResult="orderResult"></gift-complete>
    <reload-complete v-if="isOrderSuccess && isReload" :orderResult="orderResult"></reload-complete>
  </div>
</template>

<script>
import GiftComplete from "@/views/products/giftComplete";
import OrderComplete from "@/views/products/orderComplete";
import ReloadComplete from "@/views/cards/reloadComplete";
import axios from 'axios';

export default {
  name: "orderResult",
  components: { GiftComplete, OrderComplete, ReloadComplete },

  data() {
    return {
      /** @type {Boolean} 주문성공값 */
      isOrderSuccess: false,
      /** @type {Boolean} 주문실패값 */
      isOrderFail:false,
      /** @type {Object} 카드 발급 결제 요청 객체 */
      prepaidCardPaymentRequest: {
        /** @type {string} 고객사 번호 */
        ctmmnyNo: '',
        /** @type {string} 주문번호 */
        orderNo: '',
        /** @type {string} PG 거래 ID - PG사 마다 사용하는 용어들이 다를 수 있다. */
        transactionId: '',
        /** @type {number} 결제금액 */
        amount: 0,
      },
      /** @type {Object} 주문 요청 결과 객체 */
      orderResult : {},
      /** @type {Boolean} 발급 여부 */
      isIssue: null,
      /** @type {Boolean} 선물 여부 */
      isGift: null,
      /** @type {Boolean} 충전 여부 */
      isReload: null,
      /** @type {Object} 카드 정보 */
    }
  },

  methods:{
    preventBack: function() {
      if(!this.$store.state.orderResultBack) { // 홈 -> 구매/선물완료 뒤로가기 시 이마트앱 이동(해당 로직 비활성화)
        if(!this.isAwaradLogin()) window.location.href = "emart-today://goback/?enable=N" // 뒤로가기 미허용
      }
    },
    /**
     * 선불카드 구매(발급,충전,선물) api를 호출하기 위한 옵션 세팅 메소드
     * @returns {{method: string, url: string, data: {} }}
     */
    setPaymentRequestOptions(){
      return {
        method: 'POST',
        url: this.$store.state.isMberPwdAuthenticated? '/api/v1.0.0/prepaid-card/payment' : '/api/v1.0.0/emarticon/payment',
        data: {
          ...this.prepaidCardPaymentRequest
        }
      };
    },
    /**
     * 선불카드 구매(발급,충전,선물) api를 호출하는 메소드
     */
    async setPrepaidCard(){
      try{
        this.prepaidCardPaymentRequest.ctmmnyNo = this.$store.state.partnerId;
        this.prepaidCardPaymentRequest.transactionId = this.$route.query.paymentKey;
        this.prepaidCardPaymentRequest.amount = Number(this.$route.query.amount);
        this.prepaidCardPaymentRequest.orderNo = this.$route.query.orderId;

        // 금액이 숫자가 아니면 예외 처리
        const amountCheck = Number.isNaN(this.prepaidCardPaymentRequest.amount);
        if(amountCheck){
          this.goErrorPage();
        }
        // 선불카드 발급 api를 호출하기 위한 옵션 세팅 메소드 호출
        const options = this.setPaymentRequestOptions();
        //선불카드 발급 api 호출
        let orderRequest = await axios.request(options);
        if(orderRequest.status !== 200){
          if(this.isAwaradLogin()) { //시상용 분기 처리
            window.location.replace(`${process.env.VUE_APP_EMARTICON_SITE_DOMAIN}/award/emarticonAwardHome?code=${orderRequest.status}&message=${orderRequest.message}`,);
          } else {
            window.location.replace(`${process.env.VUE_APP_EMARTICON_SITE_DOMAIN}/home?code=${orderRequest.status}&message=${orderRequest.message}`,);
          }
          return;
        }

        this.orderResult = orderRequest.data.data;
        let mberInfo = {
          mberNo : this.orderResult.mberNo
        }

        this.$store.commit("setMberInfo", mberInfo);

        this.isOrderSuccess = true;
        //giftInfo의 receiver가 null,undefined 이면 false 아니면 true
        this.isGift = this.orderResult.giftInfo.receiver;

        // 결제사유에 따라 flag값 수정
        switch(this.orderResult.paymentReason) {
          case 'ISSUE':
            this.isIssue = true;
            break;
          case 'GIFT':
            this.isGift = true;
            break;
          case 'RELOAD':
            this.isReload = true;
            break;
        }
      } catch(err) {
        this.isOrderFail = true;
        const errorPath = '/error'
        if (this.$route.path !== errorPath) {
          await this.$router.push({path: "/error"});
        }
      }
    },
    /**
     * 에러페이지로 이동하는 함수
     */
    goErrorPage(){
      this.$router.push({ path: "/error" });
    },
    /**
     * 시상용 로그인 체크
     */
    isAwaradLogin() {
      if(this.$store.state.mberInfo.mberNo && this.$store.state.mberInfo.mberNo.substring(0,1) != 'C') {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted(){
    this.preventBack();
    // 선불카드 발급 api 호출
    this.setPrepaidCard();
  },
}
</script>

<style scoped>

</style>